/*
 * @Author: Veto [关于活动部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-03-15 18:43:41
 */

import ProfitMain from '../views/profit/main';

import JiFen from '../views/profit/subpage/jifen';
import Diamond from '../views/profit/subpage/diamond';
import Account from '../views/profit/subpage/account';
import AccountBank from '../views/profit/subpage/account_bank';
import AccountAli from '../views/profit/subpage/account_ali';

import PasswordSet from '../views/profit/subpage/password_set';
import PasswordSetSecond from '../views/profit/subpage/password_set_second.vue';
import PasswordReset from '../views/profit/subpage/password_reset.vue';

import Debt from '../views/profit/subpage/debt';


const router = {
    '/profit': ProfitMain,
    '/profit-dev': ProfitMain,
    '/profit-jifen': JiFen,
    '/profit-diamond': Diamond,

    '/profit-account': Account,
    '/profit-account-bank': AccountBank,
    '/profit-account-ali': AccountAli,

    '/profit-password': PasswordSet,
    '/profit-password-second': PasswordSetSecond,
    '/profit-password-reset': PasswordReset,

    '/profit-debt': Debt
};


export default router;